import api from "@/libs/api";
import Config from "@/libs/config";
import { IObject } from "@/types/common-types";
import { IOrderParams } from "@/types/order-types";

export const overbooking = async (businessID: string, orderData: IOrderParams) => {
  try {
    return await api.post(`${Config.urls.todayUrl}/svc/oms/public/api/v1/device/orders?with_payment_link=true`,
    orderData,
    {
      headers: {
        'x-p-business-id': businessID,
        'X-Platform-From': 14,
      }
    });
  } catch (error) {
    console.error(error);
    return undefined;
  }

};

export const getOrderDetails = async (number: string, businessID: string): Promise<IObject | undefined> => {
  let result = undefined;
  try {
    const resp: any = await api.get(`${Config.urls.mainBindo}/services/oms/b2c/businesses/${businessID}/orders/${number}`,
    {
      headers: {
        'x-p-business-id': businessID,
        'X-Platform-From': 14,
      }
    });

    if (resp && resp.code === 200 && resp.data) {
      result = resp.data
    }
  } catch (error) {
    console.error(error);
    return result;
  };

  return result;
};

export const getOrderDetailsByEndpoint = async (number: string, businessID: string): Promise<IObject | undefined> => {
  let result = undefined;
  try {
    const resp: any = await api.post(`${Config.urls.endpointUrl}/svc/oms/public/api/v1/device/orders/check?with_payment_link=true`,
    {
      order: {
        reference_number: number,
      },
    },
    {
      headers: {
        'x-p-business-id': businessID
      }
    });

    if (resp && resp.code === 200 && resp.data) {
      result = resp.data
    }
  } catch (error) {
    console.error(error);
    return result;
  }

  return result;
};